var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZendesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3571 10.2857V27.7143H0L14.3571 10.2857ZM14.3571 4C14.3571 8 11.1429 11.2143 7.14286 11.2143C3.14286 11.2143 0 8 0 4H14.3571ZM16.7143 27.6429C16.7143 23.6429 19.9286 20.4286 23.9286 20.4286C27.9286 20.4286 31.1429 23.6429 31.1429 27.6429H16.7143ZM16.7143 21.4286V4H31.1429L16.7143 21.4286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/zendesk.1a2472c90887501fc04c5475b197397e.svg";
export { ForwardRef as ReactComponent };